import { render, staticRenderFns } from "./ModuleList.vue?vue&type=template&id=e51d83fa&"
import script from "./ModuleList.vue?vue&type=script&lang=ts&"
export * from "./ModuleList.vue?vue&type=script&lang=ts&"
import style0 from "./ModuleList.vue?vue&type=style&index=0&id=e51d83fa&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports